// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"babeefff","783":"9082844c","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};